export var parseIsoDate = function (iso) {
    var _a = iso.split("-").map(Number), year = _a[0], month = _a[1], day = _a[2];
    return new Date(year, month - 1, day);
};
export var toIsoDateString = function (date) {
    var year = date.getFullYear();
    var month = String(date.getMonth() + 1).padStart(2, "0");
    var day = String(date.getDate()).padStart(2, "0");
    return "".concat(year, "-").concat(month, "-").concat(day);
};
